<template>
  <div class="demo-set-wrap">
    <Spin fix class="ivu-spin-fullscreen" :class="{'dt-none': isLoading === false }">
      <Icon type="load-c" size="18" class="demo-spin-icon-load"></Icon>
      <div>加载中。。。</div>
    </Spin>
    <header>排班参数</header>
    <div class="content">
      <!-- <div class="option-wrap">
        <div class="title">业务员数量</div>
        <InputNumber :min="1" v-model="regionNum" placeholder="请输入" class="input-wrap"></InputNumber>
      </div> -->
      <div class="option-wrap">
        <div class="title">工作时间</div>
        <TimePicker
          @on-change="timeChange"
          type="timerange"
          :value="setTime"
          format="HH:mm"
          placement="bottom-end"
          placeholder="请选择"
          class="input-wrap time-picker-wrap"
        ></TimePicker>
      </div>
      <div class="option-wrap">
        <div class="title">每日最多拜访客户数</div>
        <InputNumber :min="1" v-model="maxVisit" placeholder="请输入" class="input-wrap"></InputNumber>
      </div>
      <!-- <div class="option-wrap">
        <div class="title">最小时间间隔</div>
        <InputNumber :min="1" v-model="dayInterval" placeholder="请输入" class="input-wrap"></InputNumber>
        <span class="unit">天</span>
      </div> -->
      <div class="option-wrap option-vehicle-type-wrap">
        <div class="title">交通方式</div>
        <ul class="vehicle-type">
          <li v-for="(item, index) in vehicleTypeList" :key="item.title"
              :class="vehicleType === item.type ? 'active' : ''" @click="vehicleType = item.type">{{item.title}}
          </li>
        </ul>
      </div>
      <div class="option-wrap">
        <div class="title">排班月份</div>
        <DatePicker
          @on-change="dateChange"
          :value="setMonth"
          type="month"
          placeholder="请选择"
          class="input-wrap date-picker-wrap"
        ></DatePicker>
      </div>
      <Button class="submit-btn" @click="setClick">保存参数并规划</Button>
    </div>
  </div>
</template>
<script>
  import getData from "../service/getData";
  import api from "../service/api";
  import moment from "moment";

  export default {
    data: function () {
      return {
        userId: "",
        taskId: "",
        vehicleType: 21,
        vehicleTypeList: [
          { type: 1, title: '步行' },
          { type: 3, title: '驾车' },
          { type: 21, title: '公交+步行' },
          { type: 231, title: '公交+驾车+步行' }
        ],
        regionNum: 1,
        dayInterval: 1,
        maxVisit: 20,
        setMonth: "2019-01",
        setTime: ["08:00", "16:00"],
        intervalId: null, //定时发送请求
        isLoading: false
      };
    },
    mounted () {
      //初始化地图
      const userId = sessionStorage.getItem("userId");
      if (!userId) {
        this.$router.push({ path: "/demo-login" });
      }
      this.userId = userId;
      this.getOption();
    },
    methods: {
      timeChange: function (getTime) {
        this.setTime = getTime;
      },
      dateChange: function (getMonth) {
        this.setMonth = getMonth;
      },
      setClick: function () {
        this.setOption();
      },
      setOption: async function (params) {
        const startH = moment(this.setTime[0], "HH:mm");
        const endH = moment(this.setTime[1], "HH:mm");
        let workHour = endH.diff(startH, "minutes");
        //设置参数
        if (!this.regionNum) {
          //缺少业务员数量
          return this.$Message.info("请选择业务员数量");
        }
        if (!this.maxVisit) {
          return this.$Message.info("请选择每日最多拜访客户数");
        }
        if (!this.dayInterval) {
          return this.$Message.info("请选择最小时间间隔");
        }
        this.isLoading = true;
        const res = await getData.post(api.setOption, {
          userId: this.userId,
          vehicle_type: this.vehicleType, //步行:1 公交:2 驾车:3  公交+步行:21  公交+驾车+步行:231
          max_visits: this.maxVisit,
          region_count: this.regionNum,
          work_hour: workHour,
          day_interval: this.dayInterval,
          month: this.setMonth,
          start_work_time: this.setTime[0],
          end__work_time: this.setTime[1]
        });
        if (res.data && res.data.status) {
          const option = res.data.data;
          this.taskId = res.data.taskId;
          this.showOption(option);
          this.intervalId = setInterval(this.getResStatus, 5000);
        }
      },
      getResStatus: async function () {
        const res = await getData.get(api.getResStatus, { userId: this.userId, taskId: this.taskId });
        if (res.data && res.data.status) {
          if (res.data.data.finish) {
            this.isLoading = false;
            clearInterval(this.intervalId);
          }
          this.$Message.info(res.data.data.msg);
        } else {
          this.$Message.info(res.data.msg);
        }
      },
      getOption: async function () {
        //获取参数设置
        const res = await getData.get(api.getOption, { userId: this.userId });
        if (res.data && res.data.status) {
          const option = res.data.data;
          this.showOption(option);
        }
      },
      showOption (option) {
        this.regionNum = option.region_count;
        this.vehicleType = option.vehicle_type;
        this.dayInterval = option.day_interval;
        this.maxVisit = option.max_visits;
        this.setMonth = option.month;
        this.setTime = [option.start_work_time, option.end__work_time];
      }
    }
  };
</script>
<style lang="sass">
  @import "../assets/stylesheets/set_demo"
</style>



// WEBPACK FOOTER //
// src/components/DemoSet.vue